// rem 转换 根据屏幕大小设置适配公共变量
const fun = (doc, win) => {
  const docEl = doc.documentElement;
  const resizeEvt =
    'orientationchange' in window ? 'orientationchange' : 'resize';
  const recalc = () => {
    const clientWidth = docEl.clientWidth;
    if (!clientWidth) return;
    docEl.style.fontSize = `${100 * (clientWidth / 1920)}px`;
    let mul = 1;
    if (clientWidth === 1920) {
      mul = 1;
    } else {
      mul = parseFloat(clientWidth / 1920);
    }
    // store.commit('other/setMul', mul);
  };
  if (!doc.addEventListener) return;
  win.addEventListener(resizeEvt, recalc, false);
  doc.addEventListener('DOMContentLoaded', recalc, false);
};
fun(document, window);



// WEBPACK FOOTER //
// ./src/utils/rem.js